module.exports = __webpack_public_path__ + "static/media/eml.3c13439b.png";